import { DownloadMergeFileRequset } from 'src/app/core/models/transport-operation/download-merge-file-request';
import { HttpEventType } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { ShippingDocumentService } from 'src/app/core/services/shipping-document.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DeliveryOrderService } from '../../transport-operation/services/delivery-order.service';

@Component({
  selector: 'laas-dofile-management',
  templateUrl: './dofile-management.component.html',
  styleUrls: ['./dofile-management.component.scss'],
})
export class DofilemanagementComponent
  extends SessionBaseComponent
  implements OnInit, OnChanges
{
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Input() doNo!: string;
  @Input() display!: boolean;
  @Input() fileType?: string;
  @Output() onClose = new EventEmitter<boolean>();

  documentOptions: any[];
  selectedDocument: string;
  docs: any[];
  isLoading: boolean;
  selectedDoc: any;
  title: any;
  downloadMergeFileParams: DownloadMergeFileRequset =
    new DownloadMergeFileRequset();

  constructor(
    injector: Injector,
    private DOService: DeliveryOrderService,
    private commonDataService: CommonDataService,
    private shippingDocumentService: ShippingDocumentService
  ) {
    super(injector);
    this.documentOptions = [];
    this.selectedDocument = '';
    this.docs = [];
    this.isLoading = false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.display) {
      return;
    }

    for (let propertyName in changes) {
      if (propertyName == 'doNo') {
        if (!isNullOrEmpty(this.doNo)) {
          this.getDocOptions(true);
        }
      }
    }
  }

  getDocOptions(isLoadDocs: boolean): void {
    var fileType = this.fileType ?? 'DeliveryOrder';

    if (fileType == 'Warehousing') {
      this.commonDataService
        .getCodeConverter(
          this.laasSetting.language,
          'DropdownList',
          'warehousingDoc'
        )
        .subscribe({
          next: (options: any[]) => {
            this.documentOptions = options.map((x) => ({
              text: x.codeDesc,
              value: x.codeKey,
            }));

            this.translateService.get('Common.DropDown.Select').subscribe({
              next: (str) => {
                this.documentOptions.unshift({
                  text: str,
                  value: '',
                });
              },
            });

            if (isLoadDocs) {
              this.searchDocuments();
            }
          },
        });
    } else {
      this.shippingDocumentService
        .getDocumentOptions(this.laasSetting.language, this.doNo, fileType)
        .subscribe({
          next: (result) => {
            this.documentOptions = result;

            this.translateService.get('Common.DropDown.Select').subscribe({
              next: (str) => {
                this.documentOptions.unshift({
                  text: str,
                  value: '',
                });
              },
            });

            if (isLoadDocs) {
              this.searchDocuments();
            }
          },
        });
    }
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  searchDocuments(): void {
    this.isLoading = true;
    var docTypes = [...this.documentOptions.map((x) => x.value)];

    var searchObj = {
      docReference: [
        {
          key: this.doNo,
          name: this.fileType ?? 'DeliveryOrder',
        },
      ],
      docType: docTypes,
    };

    this.shippingDocumentService.getDocs(searchObj).subscribe({
      next: (result) => {
        this.docs = result.body;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  hideDialog(event: any): void {
    this.onClose.emit(this.display);
  }

  downloadChange(event: any, downnloadObj: any) {
    this.selectedDoc = downnloadObj;
    var searchObj = {
      sn: this.selectedDoc.docId,
      version: this.selectedDoc.version,
    };

    if (this.selectedDoc.docType == 'ProofOfDelivery') {
      this.downloadMergeFileParams.docReference = null;
      this.downloadMergeFileParams.remarks = null;
      this.downloadMergeFileParams.docTypes =
        this.selectedDoc.docType.split(',');
      this.downloadMergeFileParams.referenceKeys = this.doNo.split(',');
      this.shippingDocumentService
        .downloadMergeFile(this.downloadMergeFileParams)
        .subscribe({
          next: (downloadMergeFileResponse) => {
            // 判斷isMutipleFile的值是MULTIPLE還是SINGLE決定是否壓縮成zip
            if (downloadMergeFileResponse.isMutipleFile == 'MULTIPLE') {
              const byteStr = atob(downloadMergeFileResponse.file);
              const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
              const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

              for (let i = 0; i < byteStr.length; i++) {
                int8Array[i] = byteStr.charCodeAt(i);
              }

              const data: Blob = new Blob([int8Array], {
                type: 'application/zip',
              });
              const url = URL.createObjectURL(data);
              const linkEle = document.createElement('a');
              linkEle.href = url;
              linkEle.download = downloadMergeFileResponse.fileName;
              linkEle.click();
              URL.revokeObjectURL(url);
              linkEle.remove();
              this.loader.hide();
            } else {
              const byteStr = atob(downloadMergeFileResponse.file);
              const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
              const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

              for (let i = 0; i < byteStr.length; i++) {
                int8Array[i] = byteStr.charCodeAt(i);
              }

              var blob = new Blob([int8Array], {
                type: 'application/octet-stream',
              }); // application後面接下載的副檔名
              let url = window.URL.createObjectURL(blob);
              let linkEle = document.createElement('a');
              linkEle.href = url;
              linkEle.download = `${this.selectedDoc.docType}.${this.selectedDoc.fileType}`; // 瀏覽器下載時的檔案名稱
              linkEle.click();
            }
          },
        });
    } else {
      this.DOService.downloadFile(searchObj).subscribe((x) => {
        var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

        let downloadURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        link.download = `${this.selectedDoc.docType}.${this.selectedDoc.fileType}`; // 瀏覽器下載時的檔案名稱
        link.click();
      });
    }
  }

  deleteFileBtn(event: any, deleteObj: any): void {
    this.confirmationService.confirm({
      target: event.target,
      message: '確定要刪除嗎?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteFile(event, deleteObj);
      },
      reject: () => {
        //reject action
      },
    });
  }

  deleteFile(event: any, deleteObj: any): void {
    if (deleteObj.docType == 'ProofOfDelivery') {
      this.shippingDocumentService
        .deleteFileBySnCode(deleteObj.docId)
        .subscribe({
          next: (result) => {
            this.toastService.success(
              this.translateService.instant(
                'BoookingSearch.Success.DeleteSuccess'
              ),
              false
            );
            this.getDocOptions(true);
          },
          error: (result) => {
            this.toastService.error(
              this.translateService.instant('BoookingSearch.Error.DeleteFail')
            );
          },
        });
    } else {
      this.shippingDocumentService.deleteFile(deleteObj.seqNo).subscribe({
        next: (result) => {
          this.toastService.success(
            this.translateService.instant(
              'BoookingSearch.Success.DeleteSuccess'
            ),
            false
          );
          this.getDocOptions(true);
        },
        error: (result) => {
          this.toastService.error(
            this.translateService.instant('BoookingSearch.Error.DeleteFail')
          );
        },
      });
    }
  }

  clearUploadUI(): void {
    this.selectedDocument = '';
    this.fileUpload.progress = 0;
    this.fileUpload.clear();
  }

  fileUploader(event: any): void {
    this.loader.show();

    if (this.selectedDocument === '') {
      this.toastService.warn(
        this.translateService.instant('BoookingSearch.Alert.FileType'),
        false
      );
      this.loader.hide();
      return;
    }

    var uploadObj = {
      docType: this.selectedDocument,
      docReference: {
        name: this.fileType ?? 'DeliveryOrder',
        key: this.doNo,
      },
      operatorName: this.userProfile.userName,
      remark: this.doNo,
    };
    this.shippingDocumentService
      .uploadFile(event.files[0], uploadObj)
      .subscribe({
        next: (rsp) => {
          if (rsp.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            const percentDone = Math.round((100 * rsp.loaded) / rsp.total);
            this.fileUpload.progress = percentDone;
          }
          if (rsp.type === HttpEventType.Response) {
            if (rsp.status == 200) {
              this.toastService.success(
                this.translateService.instant(
                  'BoookingSearch.Success.Uploadsuccess'
                ),
                false
              );
              this.getDocOptions(true);
            }
          }
        },
        error: (rsp) => {
          let invalidFileType = rsp.error.errorMsg;
          let errorCode = rsp.error.errorCode;
          let category = rsp.error.category;
          this.commonDataService.getErrorCodes(this.laasSetting.language, category).subscribe({
          next: (errorList) => {
            // find error that has the errorCode in  errorList
            let matchedError = errorList.find((error: any) => error.errorCode == errorCode)

            this.toastService.error(matchedError.errorMsg + invalidFileType);
          }
        })
          this.loader.hide();
        },
        complete: () => {
          this.clearUploadUI();
          this.loader.hide();
        },
      });
  }

  getDialogTitle(): string {
    this.translateService.get('DOQuery.Form.FileUpload.DO').subscribe({
      next: (str) => {
        this.title = str;
      },
    });
    switch (this.fileType) {
      case 'Booking':
        this.title = 'Booking';
        break;
      case 'Warehousing':
        this.translateService.get('ReceiptFormUpload.ReceiptNum').subscribe({
          next: (str) => {
            this.title = str;
          },
        });

        break;
    }
    return this.title;
  }
}
